module.exports = __webpack_public_path__ + "img/money-white.2ea9e985.svg";